import { render, staticRenderFns } from "./SurveyGenerationModePicker.vue?vue&type=template&id=672caa2d&scoped=true"
import script from "./SurveyGenerationModePicker.vue?vue&type=script&lang=js"
export * from "./SurveyGenerationModePicker.vue?vue&type=script&lang=js"
import style0 from "./SurveyGenerationModePicker.vue?vue&type=style&index=0&id=672caa2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672caa2d",
  null
  
)

export default component.exports